export const MODAL_TYPE_EDIT_POST = 'edit-post';
